import React from 'react';
import { AfterAuth, AppUI } from '@seedlang/state';

const NON_RETURNABLE_ROUTE_NAMES = ['user.reset_password', 'unpublished'];

let previousLocation = null;

function isOnboardingRoute(routeName) {
  return Boolean(routeName?.startsWith('onboarding'));
}

function isReturnable(routeName) {
  if (!routeName || isOnboardingRoute(routeName) || NON_RETURNABLE_ROUTE_NAMES.includes(routeName)) return false;
  return !(AppUI.siteIsSeedlang && routeName === 'landing');
}

// Remembers the page a user was on when they entered the sign-in/sign-up flow, so they can be sent back after authenticating.
// Forgets it when they leave the flow, so an abandoned sign-in doesn't redirect them later.
export default function useAuthReturnPath(location, routeName) {
  React.useLayoutEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    if (previousLocation?.path === path) return;

    const enteringOnboarding = isOnboardingRoute(routeName) && previousLocation && !isOnboardingRoute(previousLocation.routeName);
    const leavingOnboarding = !isOnboardingRoute(routeName) && isOnboardingRoute(previousLocation?.routeName);

    if (enteringOnboarding && isReturnable(previousLocation.routeName)) {
      AfterAuth.set({ path: previousLocation.path });
    } else if (enteringOnboarding || leavingOnboarding) {
      AfterAuth.clear();
    }
    previousLocation = { path, routeName };
  }, [location, routeName]);
}
